import CommonService from './commonService';
var ref = window.location.host.replace('www.', '');
let urlHref = window.location.href;
console.log({ mainRef: urlHref });
if (urlHref.includes('expresosantacruz') && urlHref.includes('/contact')) {
	console.log({ refBefore: urlHref });
	ref = urlHref.replace('/contact', '');
	console.log({ refAfterFormation: ref });
	window.location.href = ref;
}
const AppData = {
	BASE_URL: 'https://newstg3-bus.kupos.cl/',
	//BASE_URL: 'https://api.pasajebus.com/',
	ONE_SIGNAL_APP_ID: '234fd2db-ea84-4b59-ab4b-28a3ea826474',
	SENDER_ID: '7308679025w68',
	MAP_API_KEY: 'AIzaSyAZwHr1fuhn2Jh5dsENAPuGJJT4iTJpdCM',
	FB_APP_ID: '409783556699660',
	// FB_APP_ID: '177184106959636',
	X_OP_APP_DOMAIN: window.location.host.replace('www.', ''),
	// X_OP_APP_DOMAIN: ref,
	X_OPSITE: true,
	//IS_STAGE: true,
	//X_OP_APP_DOMAIN: 'serenamar.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'jetsur.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'kennybus.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'barriaghisoni.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'viatur.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'andimar.cl',
	//X_OP_APP_DOMAIN: 'andimar.pasaje.cl',
	//X_OP_APP_DOMAIN: 'andimar.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 'expressonorte.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'cormarbus.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 'cormarbus.cl',
	//X_OP_APP_DOMAIN: 'bahiaazul.newstg2-opsdweb.kupos.cl/',
	//X_OP_APP_DOMAIN: 'ivergrama.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 'tepual.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'saopaulo.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'pullmansanandres.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'fernandez.newstg2-opsdweb.kupos.cl/',
	//X_OP_APP_DOMAIN: 'combarbala.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 'trrass.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 't-rrasschile.cl/',
	//X_OP_APP_DOMAIN: 'expresosantacruz.cl/',
	//X_OP_APP_DOMAIN: 'expresosantacruz.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'ahumada.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'sanantonio.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'erbuc.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'thaebus.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'centraltour.newstg2-opsdweb.kupos.cl',
	// X_OP_APP_DOMAIN: 'tacoha.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'liquine.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'traveltur.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'tarapaca.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'centropuerto.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'pullmandelsur.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'santamaria.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'biaggini.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'santajuana.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'busnorte.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'aeroquinta.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'chilebus.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'lineaazul.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'lineaazul.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'arzola.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'jeldres.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'santarosa.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'buseslafit.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'losnavegadores.newstg2-opsdweb.kupos.cl',
	//X_OP_APP_DOMAIN: 'torres.newstg2-opsdweb.kupos.cl',
    //   X_OP_APP_DOMAIN: 'jm.newstg2-opsdweb.kupos.cl',

	generateServerData: () => {
		// Your server-side logic here
		let lastIndex = 30;
		return CommonService.createJwtFull2(
			{
				jwt_string: CommonService.makeId(32) + lastIndex,
				exp: Math.floor(Date.now() / 1000) + 60 * 30,
			},
			20,
			lastIndex,
		);
	},
};
export default AppData;



// WEBPACK FOOTER //
// ./src/services/appData.js